import { Breadcrumbs, Stack, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

const CustomBreadCrumb = ({
    list=[],
    activeSection
}) => {
    return (
        <>
            <Stack
                direction='row'
                justifyContent={{xs: 'center', md: 'start'}}
                width='100%'
                pb={{xs: 2, md: 5}}
            >
                <Breadcrumbs 
                    aria-label="breadcrumb" 
                    separator="/"
                >
                    {
                        list.map((item, index) => {
                            return <Link
                                key={index}
                                color="inherit" 
                                to={item.link}
                                style={{
                                    textDecoration: 'none'
                                }}
                            >
                                <BreadcrumbText text={item.label}/>
                            </Link>
                        })
                    }

                    <BreadcrumbText text={activeSection} active/>
                </Breadcrumbs>
            </Stack>
        </>
    );
}

export default CustomBreadCrumb;

const BreadcrumbText = ({text, active=false}) => {
    const theme = useTheme();

    return (
        <>
            <Typography
                fontWeight={active ? 700 : 400}
                fontSize={{xs: 12, md: 16}}
                textAlign='left'
                lineHeight={{xs: 1.5, md: 2}}
                color={theme.palette.text.secondary}
                sx={{
                    '&: hover': {
                        transform: active ? 'scale(1)' : 'scale(1.1)',
                        color: active ? theme.palette.text.secondary : theme.palette.primary.main,
                        fontWeight: 700
                    }
                }}
            >
                {text}
            </Typography>
        </>
    );
}